@if(loading$ | async) {
<mat-progress-bar class="primary-progress-bar" mode="indeterminate"></mat-progress-bar>
}

<div class="flex flex-col h-full">
  @if (showMessageInput) {
  <div class="p-2 flex items-center gap-1 border-bottom">
    <mat-form-field class="flex-auto" subscriptSizing="dynamic">
      <mat-label>{{ 'personal_content.coop.message' | transloco }}</mat-label>
      <input #message matInput />
    </mat-form-field>
    <button
      (click)="onSendMessageToCollection(message.value)"
      [disabled]="!message.value"
      mat-icon-button
      [loading]="loading$ | async"
    >
      <mat-icon>send</mat-icon>
    </button>
  </div>
  }

  <mat-drawer-container [autosize]="true" class="h-full border-top">
    <mat-drawer #drawer class="max-w-[300px]" mode="side" opened>
      <mat-accordion displayMode="flat" multi>
        <mat-expansion-panel class="mat-elevation-z0" expanded>
          <mat-expansion-panel-header>
            {{ 'personal_content.coop.users' | transloco }}
          </mat-expansion-panel-header>

          <pc-message-user-list
            (sendMessageToUser)="onSendMessageToUser($event)"
            [currentUserId]="userId"
            [users]="users$ | async"
          ></pc-message-user-list>
        </mat-expansion-panel>

        <mat-expansion-panel class="mat-elevation-z0" expanded>
          <mat-expansion-panel-header>
            {{ 'personal_content.coop.collections' | transloco }}
          </mat-expansion-panel-header>

          <pc-message-collection-list
            (openCollection)="onOpenCollection($event)"
            (openCollectionInTab)="onOpenCollectionInTab($event)"
            (sendMessageToCollection)="onSendMessageToCollectionDialog($event)"
            [collectionId]="collectionId"
            [collections]="(coopSummary$ | async)?.collections"
            [userId]="userId"
          ></pc-message-collection-list>
        </mat-expansion-panel>

        @if (showFilters) {
        <mat-expansion-panel class="mat-elevation-z0" expanded>
          <mat-expansion-panel-header>
            {{ 'personal_content.coop.filter.title' | transloco }}
          </mat-expansion-panel-header>
          <pc-message-filter
            (filter)="onFilter($event)"
            [activeFilters]="activeFilters$ | async"
            [filters]="filters$ | async"
            [lang]="lang$ | async"
          ></pc-message-filter>
        </mat-expansion-panel>
        }
      </mat-accordion>
    </mat-drawer>

    <mat-drawer-content class="bg-white">
      <div class="p-3 flex justify-between">
        <button (click)="drawer.toggle()" mat-icon-button>
          <mat-icon>{{ drawer.opened ? 'chevron_left' : 'chevron_right' }}</mat-icon>
        </button>

        <button (click)="onRefresh()" mat-icon-button>
          <mat-icon class="text-primary">refresh</mat-icon>
        </button>
      </div>

      <pc-message-list
        (sendMessageToUser)="onSendMessageToUser($event)"
        [lang]="lang$ | async"
        [messages]="messages$ | async"
      ></pc-message-list>
    </mat-drawer-content>
  </mat-drawer-container>
</div>
